// extracted by mini-css-extract-plugin
export var banner = "_g2-0";
export var closeButton = "_g2-2";
export var greenCheckmark = "_g2-3";
export var hereLink = "_g2-4";
export var titleIcon = "_g2-1";